import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./StaffIngredientsMgmt.module.css";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../../../assets/images/actionicon.svg";
import filtericon from "../../../../../assets/images/filter.svg";
import { Dropdown, Modal, SearchInput, TextComponent } from "../../../../../components";

import { SubmitButton } from "../../../../../components";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";


const { Option } = Select;
const categoryOpt = [
  {
    value: "Category",
    role: "Category",
    id: 1,
  },
  {
    value: "Flour",
    role: "Flour",
    id: 2,
  },
  {
    value: "Additives",
    role: "Additives",
    id: 3,
  },
  {
    value: "Toppings",
    role: "Toppings",
    id: 4,
  }
]

const AdminBakerySetup = () => {
  const navigate = useNavigate();
  const [filterModal, setFilterModal] = useState(false);
  const [category, setCategory] = useState({
    value: "Category",
    role: "Category",
    id: 1,
  });


  const columns = [
    {
      title: "Ingredient Name",
      dataIndex: "IngredientName",
      key: "IngredientName",
      render: (text, record) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
          {(record.IngredientName === "Bread Flour" ||
            record.IngredientName === "Margarine" ||
            record.IngredientName === "Almonds") && (
              <img src={actionicon} alt="icon" className={styles.iconImg} />
            )}
        </div>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
    },
    {
      title: "Category",
      key: "Category",
      dataIndex: "Category",
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },


  ];

  const data = [
    {
      IngredientName: "Bread Flour",
      Quantity: "2 lbs",
      Category: "Flour",
      Button:
        <SubmitButton
          title={"view"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/StaffWarehouse/StaffAdjustStock")}
        />
    },
    {
      IngredientName: "Instant Yeast",
      Quantity: "36 oz",
      Category: "Additives",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffAdjustStock")}
      />
    },
    {
      IngredientName: "Brown sugar",
      Quantity: "3 lbs",
      Category: "Liquids",

      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffAdjustStock")}
      />
    },
    {
      IngredientName: "Margarine",
      Quantity: "4 g",
      Category: "Toppings",
      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffAdjustStock")}
      />
    },
    {
      IngredientName: "Olive oil",
      Quantity: "36 oz",
      Category: "Liquids",
      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffAdjustStock")}
      />
    },
    {
      IngredientName: "Whole milk",
      Quantity: "3 lbs",
      Category: "Additives",
      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffAdjustStock")}
      />
    },
    {
      IngredientName: "Almonds",
      Quantity: "2 lbs",
      Category: "Toppings",
      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffAdjustStock")}
      />
    },
    {
      IngredientName: "Buttermilk",
      Quantity: "4 g",
      Category: "Liquids",
      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffAdjustStock")}
      />
    },
    {
      IngredientName: "Brown sugar",
      Quantity: "3 lbs",
      Category: "Toppings",
      Button: <SubmitButton
        title={"view"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/StaffWarehouse/StaffAdjustStock")}
      />
    },
  ];

  return (
    <div className={styles.mainCont}>
      {/* Heading Section with Right Controls */}
      <HeaderComponent
        heading={"Ingredients "}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/Warehouse/IngredientsMgmt/CreateNewGradient")}
        rightControlsStyle={styles.rightControlsStyle}
        showControlButtons={false}
        showFilterIcon={true}
        showBackIcon={false}
        showSearch={true}
        onClickFilter={() => setFilterModal(true)}

      />

      {/* Table Section */}
      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>


      {/* //////////////////// Filters ////////////////////// */}

      <Modal
        open={filterModal}
        onCancel={() => {
          setFilterModal(false);
        }}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Apply Filters(1)"}
        cancelBtnTitle={"Reset All"}
        onClickCancelButton={() => setFilterModal(false)}
        onClickOkButton={() => {
          setFilterModal(false)
        }}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <Dropdown
          // label={"Category"}
          // labelClass={styles.DropDownLabel}
          value={category}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={categoryOpt}
          onChange={(e) => setCategory(e)}
        />
      </Modal>
    </div>
  );
};

export default AdminBakerySetup;
